// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const BracketsIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 48 48">
    <path
      fill="#9147FF"
      d="M8 14v4a2 2 0 0 1-2 2H4v8h2a2 2 0 0 1 2 2v4c0 3.3 2.7 6 6 6h6v-4h-6a2 2 0 0 1-2-2v-4c0-2.6-1.68-4.84-4-5.66v-.68c2.32-.82 4-3.06 4-5.66v-4c0-1.1.9-2 2-2h6V8h-6c-3.3 0-6 2.7-6 6M42 20a2 2 0 0 1-2-2v-4c0-3.3-2.7-6-6-6h-6v4h6a2 2 0 0 1 2 2v4c0 2.6 1.68 4.84 4 5.66v.68A6 6 0 0 0 36 30v4a2 2 0 0 1-2 2h-6v4h6c3.3 0 6-2.7 6-6v-4c0-1.1.9-2 2-2h2v-8z"
    />
  </svg>,
  "Brackets",
);
export default BracketsIcon;
